define([ // START Open Requre.JS wrapper
	'jquery',
    'wcs.context',
    'foundation.core',
    'foundation.reveal',
	], function($, ctx) {

	'use strict';

	var tcActionCookieName = "VFEMP_DISCOUNT_TC_ACTION_",
	tcActionCookieValue = ctx.getWCCookie(tcActionCookieName,''),
	actionTaken = false,
	$tcModal = $('#modal-vf-employee-discount-terms-condition');

	if (ctx.getUserType() === 'R' && tcActionCookieValue !== '') {
		$tcModal.foundation('open');
		$(document).on('closed.zf.reveal', $tcModal, function(event) {
			if (!actionTaken) {
				updateTCAction('declined');
			}
		});
		registerClickTCModalEvents();
	}

	/**
     * registerClickTCModalEvents()
     * Registers click handlers for the VF Employee Discount TC Modal.
    */
	function registerClickTCModalEvents() {
		//Use event propagation to target all buttons within our container
		if ($tcModal) {
			$tcModal.on('click', 'button', function(e){
				var currentItem = $(e.target);
				var currentItemID = currentItem.attr('id');

				if (currentItem) {
					if (currentItemID === 'vfemp-tc-accept') {
						updateTCAction('accepted');
					} else if (currentItemID === 'vfemp-tc-decline') {
						updateTCAction('declined');
					}
					e.preventDefault();
				}
			});
		}
	}

	/**
	 * upon accept or deny we call another AJAX call to save user response in DB if accepted and add him to discount customer segment .
	 * if denied - we set session cookie in back end so user will not be presented by modal again until he logs off or closes the browser,
	 * then upon his next visit or login he will see the modal again
	 *	@param action
	 */
	function updateTCAction(action) {
		var param = {
			'action': action
		};
		$.ajax({
			url: ctx.getContextRoot() + $tcModal.data('actionUrl') ,
			type: "POST",
			data: param,
			dataType: "json"
		}).done(function(data) {
			if(data.success){
				ctx.removeWCCookie(tcActionCookieName);
				var pageName = dataLayer[0].pageName;
				if (action === 'accepted' && (pageName === 'shopcart' || pageName === 'shipping' || pageName === 'billing-review' || pageName === 'billing')) {
					submitRecalculateForm();
				}
			}
		}).fail(function() {
			console.log("T&C Action call failed");
		}).always(function() {
			actionTaken = true;
			$tcModal.foundation('close');
		});
	}

	function submitRecalculateForm() {
		var $recalculateForm = $('form.checkout-summary-recalculate-js');
		$.ajax({
			url: $recalculateForm.attr('action'),
			type: $recalculateForm.attr('method'),
			data: $recalculateForm.serialize(),
		}).done(function(response) {
			window.location.reload();
		}).fail(function() {
			console.log("Order Recalculate call failed");
		});
	}

});